const ResourceCardSkeleton = () => (
  <div className="flex flex-col gap-3 rounded-[14px] border-2 border-[#d0e2df] bg-white p-[18px]">
    <div className="h-4 w-3/4 animate-pulse rounded bg-gray-200" />
    <div className="h-3 w-1/2 animate-pulse rounded bg-gray-200" />
  </div>
);

const CategorySkeleton = () => (
  <div className="flex flex-col">
    <div className="mb-sh-15 border-b border-gray-200 p-4">
      <div className="h-5 w-32 animate-pulse rounded bg-gray-200" />
    </div>
    <div className="flex flex-col gap-sh-15">
      <ResourceCardSkeleton />
      <ResourceCardSkeleton />
    </div>
  </div>
);

export const ResourceHubSectionSkeleton = () => (
  <div className="mb-sh-30 bg-light-green">
    <div className="mb-sh-15 h-8 w-56 animate-pulse rounded bg-gray-200" />
    <div className="mb-sh-30 h-5 w-80 animate-pulse rounded bg-gray-200" />
    <div className="grid grid-cols-1 gap-sh-30 md:grid-cols-2 lg:grid-cols-4">
      <CategorySkeleton />
      <CategorySkeleton />
      <CategorySkeleton />
      <CategorySkeleton />
    </div>
    <div className="mt-sh-30">
      <div className="h-10 w-48 animate-pulse rounded-lg bg-gray-200" />
    </div>
  </div>
);
